import { jsx as m } from "react/jsx-runtime";
import { CustomerCard as k } from "../CustomerCard/CustomerCard.js";
import { useState as f, useEffect as u } from "react";
import '../../assets/CardStack.css';const i = {
  "cardstack-wrapper": "_cardstack-wrapper_1qhzj_1"
}, x = ({
  customerData: s,
  withoutText: p,
  selectedIndex: c,
  onSelectionChange: r,
  delay: d
}) => {
  const [a, _] = f(
    c ?? 0
  );
  return u(() => {
    r == null || r(a);
  }, [a, r]), /* @__PURE__ */ m("div", { className: i["cardstack-wrapper"], children: s.map((t, e) => /* @__PURE__ */ m(
    k,
    {
      customerNumber: t.customer_id,
      companyName: t.company_name,
      marketingName: t.marketing_name,
      withoutText: p,
      isOpen: a === e,
      onSelect: () => {
        _(e);
      },
      delay: d
    },
    t.customer_id
  )) });
};
export {
  x as CardStack
};
